<ng-container *ngIf="infrastructure$ | async as infrastructure">
    <div class="page-container page-container-vertical">
        <isav-unpublished-warning
            [published]="!infrastructure.draft"
            contentName="Infrastructure"
            myContentPath="my-infrastructures"
        ></isav-unpublished-warning>
        <isav-notes *isavAuthenticated="true" [iri]="infrastructure['@id']"></isav-notes>
        <isav-add-note [(hidden)]="hidden" [contentIri]="infrastructure['@id']"></isav-add-note>
        <isav-action-title
            [title]="infrastructure.name | isavTitleFallback : infrastructure['@id']"
        >
            <a
                *isavHasEditAccess="infrastructure['@id']"
                [isavEditLink]="infrastructure"
                isavBtn
                color="primary"
            >
                Edit
            </a>
            <button
                *isavHasCreateAccess="'Infrastructure'"
                [isavCloneContent]="infrastructure['@id']"
                isavBtn
                color="primary"
            >
                Clone
            </button>
            <button
                (click)="writeNote()"
                *isavAuthenticated="true"
                type="button"
                isavBtn
                color="primary"
            >
                Write note
            </button>
            <button isavBtn color="primary" isavPrintPage>Print page</button>
        </isav-action-title>
    </div>

    <isav-content-type-view [isVerticalInPrint]="true" [isAsideWider]="true">
        <isav-caption>
            Type:&nbsp;
            <isav-taxonomies-names [iris]="infrastructure.types"></isav-taxonomies-names>
        </isav-caption>
        <div isavContentTypeDetails>
            <p>
                <strong>Organisation:&nbsp;</strong>
                <isav-taxonomies-names
                    property="title"
                    [iris]="[infrastructure.organisation]"
                ></isav-taxonomies-names>
            </p>
            <p *ngIf="infrastructure.organizationLink">
                <strong>Link to organisation:&nbsp;</strong>
                <isav-external-link [link]="infrastructure.organizationLink"></isav-external-link>
            </p>
            <p *ngIf="infrastructure.externalLink">
                <strong>External link:&nbsp;</strong>
                <isav-external-link [link]="infrastructure.externalLink"></isav-external-link>
            </p>
            <p>
                <strong>Location:&nbsp;</strong>
                <span>{{ infrastructure.coordinates | isavGeoLocation }}</span>
            </p>
            <p>
                <strong>Address:&nbsp;</strong>
                <span>{{ infrastructure.address }}</span>
            </p>
            <p>
                <strong>Area code:&nbsp;</strong>
                <span>{{ infrastructure.areaCode }}</span>
            </p>
            <p>
                <strong>City:&nbsp;</strong>
                <span>{{ infrastructure.city }}</span>
            </p>
            <p>
                <strong>Region:&nbsp;</strong>
                <isav-taxonomies-names [iris]="[infrastructure.region]"></isav-taxonomies-names>
            </p>
            <p>
                <strong>Country:&nbsp;</strong>
                <isav-taxonomies-names [iris]="[infrastructure.country]"></isav-taxonomies-names>
            </p>
            <p>
                <strong>Attachments:&nbsp;</strong>
                <isav-files-link [iris]="infrastructure.attachments"></isav-files-link>
            </p>
            <h2 class="title is-1 mt-6">Infrastructure details</h2>
            <isav-description-display
                [title]="infrastructure.name || ''"
                [content]="infrastructure.description"
            ></isav-description-display>
        </div>
        <div isavContentTypeAside>
            <isav-contact-information
                [contactName]="infrastructure.contactName"
                [contactEmail]="infrastructure.contactEmail"
                [contactPhone]="infrastructure.contactPhone"
            ></isav-contact-information>
            <div class="columns is-multiline">
                <div
                    class="column"
                    [class.is-12-tablet]="hasCoords(infrastructure)"
                    [class.is-6-desktop]="hasCoords(infrastructure)"
                >
                    <img
                        *ngIf="infrastructure.image"
                        [isavApiImg]="infrastructure.image"
                        alt=""
                        aria-hidden="true"
                        class="is-fullwidth is-containing is-max-vh is-positioned-top"
                        [isavLightbox]="[infrastructure.image]"
                    />
                    <isav-image-caption [iri]="infrastructure.image"></isav-image-caption>
                </div>
                <div class="column is-12-tablet is-6-desktop" *ngIf="hasCoords(infrastructure)">
                    <isav-map
                        [hideControls]="true"
                        [showFullScreenBtn]="true"
                        [centerCoords]="infrastructure.coordinates | isavMapCoordinate"
                        [fullWidth]="true"
                    >
                        <isav-map-vector-layer>
                            <isav-map-marker
                                *ngIf="infrastructure.coordinates"
                                [coordinate]="infrastructure.coordinates | isavMapCoordinate"
                                display="point"
                                [center]="true"
                            ></isav-map-marker>
                        </isav-map-vector-layer>
                    </isav-map>
                </div>
            </div>
        </div>
    </isav-content-type-view>

    <isav-page-content>
        <isav-infrastructures-sar-view
            *isavCanViewSar="infrastructure['@id']"
            [infrastructure]="infrastructure"
        ></isav-infrastructures-sar-view>
        <isav-domain-event-journal-list
            [iri]="infrastructure['@id']"
        ></isav-domain-event-journal-list>
    </isav-page-content>
</ng-container>
